import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/reports'

Styxie.Initializers.Reports = {
  index: async(props) => {
    const { default: ReportsIndex } = await import('@/vue_widgets/reports/index.vue')
    createVueApp(ReportsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: ReportShow } = await import('@/vue_widgets/reports/show/index.vue')
    createVueApp(ReportShow, { props })
  }
}
